{
  "aiChat.notFound": "This conversation no longer exists.",
  "apiToken.create.button": "New token",
  "apiToken.create.cancel": "Close",
  "apiToken.create.error": "Failed to create the token",
  "apiToken.create.submit": "Create",
  "apiToken.create.success": "Token created",
  "apiToken.create.title": "New API token",
  "apiToken.edit.button": "Edit",
  "apiToken.edit.cancel": "Close",
  "apiToken.edit.error": "Failed to save the changes",
  "apiToken.edit.scopeCancel": "Cancel",
  "apiToken.edit.scopeConfirm": "Change",
  "apiToken.edit.scopeConfirmDescription": "The partner using this token will see different devices from now on.",
  "apiToken.edit.scopeConfirmTitle": "Really change what this token is assigned to?",
  "apiToken.edit.submit": "Save",
  "apiToken.edit.success": "Saved",
  "apiToken.edit.title": "Edit API token",
  "apiToken.form.name": "Name",
  "apiToken.form.note": "Note",
  "apiToken.form.scope": "Token applies to",
  "apiToken.form.scopeDevice": "Device",
  "apiToken.form.scopeGroup": "Group",
  "apiToken.remove.button": "Delete",
  "apiToken.remove.cancel": "Cancel",
  "apiToken.remove.confirm": "Delete",
  "apiToken.remove.confirmDescription": "The partner using this token loses API access immediately. This cannot be undone.",
  "apiToken.remove.confirmTitle": "Really delete this token?",
  "apiToken.remove.error": "Failed to delete the token",
  "apiToken.remove.success": "Token deleted",
  "apiToken.value.copied": "Token copied to clipboard",
  "apiToken.value.copy": "Copy token",
  "apiToken.value.hide": "Hide token",
  "apiToken.value.show": "Show token",
  "apiTokenList.createdAt": "Created",
  "apiTokenList.empty": "No tokens",
  "apiTokenList.name": "Name",
  "apiTokenList.title": "API tokens",
  "apiTokenList.token": "Token",
  "apiTokens.table.createdAt": "Created",
  "apiTokens.table.name": "Name",
  "apiTokens.table.note": "Note",
  "apiTokens.table.scope": "Assigned to",
  "apiTokens.table.scopeDevice": "Device: {name}",
  "apiTokens.table.scopeGroup": "Group: {name}",
  "apiTokens.table.token": "Token",
  "apiTokens.title": "API tokens",
  "auth.email": "Email",
  "auth.forgotten.button": "Send password reset email",
  "auth.forgotten.link": "Forgotten password",
  "auth.magicLink.button": "Send magic link",
  "auth.magicLink.link": "Send magic link",
  "auth.password": "Password",
  "auth.signIn.button": "Sign in",
  "auth.signIn.link": "Have an account? Sign in",
  "auth.signUp.button": "Sign up",
  "auth.signUp.link": "Don't have an account? Sign up",
  "auth.socialProvider": "Sign in with '{{provider}}'",
  "auth.update.button": "Change password",
  "auth.update.passwordLabel": "New password",
  "authResetPassword.confirm": "Confirm password",
  "authResetPassword.error": "An error occurred while changing the password.",
  "authResetPassword.password": "Password",
  "authResetPassword.submit": "Save",
  "authResetPassword.title": "Please set your password",
  "authSetPassword.confirm": "Confirm password",
  "authSetPassword.error": "An error occurred while saving the password",
  "authSetPassword.password": "Password",
  "authSetPassword.submit": "Save",
  "authSetPassword.title": "Please set your password",
  "clientPortal.docs.links": "Links",
  "clientPortal.docs.title": "Documentation",
  "clientPortal.docs.userWiki": "User WIKI",
  "clientPortal.docs.wiki": "Wiki pages",
  "clientPortal.docs.wikiInfo": "Contains a detailed user guide for setting up Infigy together with supported accessories such as PV inverter, boiler, heat pump, smart socket, and more.",
  "clientPortal.title": "Client section",
  "companySelect.label": "Company",
  "companySignUp.confirmation.close": "Close",
  "companySignUp.confirmation.text": "Your request has been successfully submitted. Once we verify the request and assign a service password, we will contact you.",
  "companySignUp.confirmation.title": "Confirmation",
  "companySignUp.error": "Failed to create request",
  "companySignUp.form.back": "Back",
  "companySignUp.form.companyName": "Company name",
  "companySignUp.form.note": "Note",
  "companySignUp.form.submit": "Confirm",
  "companySignUp.form.title": "Request to create an installer account",
  "companySignUp.noDevice.close": "Close",
  "companySignUp.noDevice.isCompany": "I am an installation company",
  "companySignUp.noDevice.text": "No device has been assigned to your account yet. Please wait for the installation company to assign one.",
  "companySignUp.noDevice.title": "No assigned device",
  "companySignUp.success": "Request was created",
  "dashboard.alert.avgCharge": "Average charge: {value}%",
  "dashboard.alert.avgTemperature": "Average temperature: {value}",
  "dashboard.alert.extraOverflow": "\"Extra\" overflow in the last 4 days: {value} kWh",
  "dashboard.alert.lastTwoDays": "Last two days: {value} kWh",
  "dashboard.alert.overflows": "Overflows: {value} kWh",
  "dashboard.alert.setTemperature": "Set temperature: {value}",
  "dashboard.betaInfo": "The dashboard is currently in BETA mode, which means you can be among the first to try it. In the future, we plan to charge for this functionality, but during BETA testing you can use all its benefits for free. We would appreciate any feedback at {email}.",
  "dashboard.chart.actualSoc": "SOC",
  "dashboard.chart.consumption": "Consumption",
  "dashboard.chart.minimalSoc": "Minimum SOC",
  "dashboard.chart.overflow": "Overflow",
  "dashboard.chart.photovoltaicsProduction": "Production",
  "dashboard.chart.temperature": "Temperature",
  "dashboard.chart.temperatureSetting": "Set temperature",
  "dashboard.col.battery": "Battery",
  "dashboard.col.batteryUndercharge": "Battery undercharge",
  "dashboard.col.boiler": "Boiler",
  "dashboard.col.criticalBatteryUndercharge": "Critical battery undercharge",
  "dashboard.col.device": "Device",
  "dashboard.col.heatPumpCommunication": "Heat pump communication",
  "dashboard.col.inverterCommunication": "Inverter communication",
  "dashboard.col.maxOverflow": "Max overflows",
  "dashboard.col.maxOverflowTotal": "Total: {count}",
  "dashboard.col.nighttimeOverflows": "Nighttime overflows",
  "dashboard.col.photovoltaics": "PV production",
  "dashboard.deviceDetail.battery": "Battery",
  "dashboard.deviceDetail.compact": "Compact",
  "dashboard.deviceDetail.detailed": "Detailed",
  "dashboard.deviceDetail.energy": "Energy",
  "dashboard.deviceDetail.layoutLabel": "Layout",
  "dashboard.deviceDetail.loadError": "An error occurred while loading",
  "dashboard.deviceDetail.waterHeater": "Hot water",
  "dashboard.filters.alert": "Alert",
  "dashboard.filters.all": "All",
  "dashboard.filters.ignored": "Ignored",
  "dashboard.filters.operational": "Operational",
  "dashboard.filters.status": "Status",
  "dashboard.filters.unknown": "Unknown",
  "dashboard.loadError": "An error occurred while loading",
  "dashboard.stats.operational": "Operational",
  "dashboard.stats.totalDevices": "Total devices",
  "dashboard.stats.withAlerts": "With alerts",
  "device.detail.createdAt": "Created",
  "device.detail.deviceId": "Device ID",
  "device.detail.email": "Email",
  "device.detail.firstUserAssignedAt": "First user assigned (installation date)",
  "device.detail.groupEmail": "Email",
  "device.detail.groupName": "Name",
  "device.detail.groups": "Groups",
  "device.detail.internalIp": "Internal IP",
  "device.detail.notifications": "Notifications",
  "device.detail.serialNumber": "Serial number",
  "device.detail.userEmail": "Email",
  "device.detail.users": "Users",
  "device.events.loadError": "An error occurred while loading",
  "device.events.showAll": "Show all",
  "device.events.title": "Event list",
  "device.export.cancel": "Cancel",
  "device.export.error": "Failed to export devices",
  "device.export.formatLabel": "Export format",
  "device.export.noVariables": "Enter at least one variable",
  "device.export.submit": "Export",
  "device.export.title": "Export devices",
  "device.export.tooltip": "Export variables from all devices",
  "device.export.variablesLabel": "Variables to export (comma-separated)",
  "device.general": "General",
  "device.labels.clear": "Discard changes",
  "device.labels.error": "Failed to save labels",
  "device.labels.save": "Save changes",
  "device.labels.success": "Labels saved",
  "device.labels.title": "Labels",
  "device.missingAirtableId": "Missing Airtable ID",
  "device.offline": "Offline",
  "device.open": "Open",
  "device.plusActive": "Infigy Plus active",
  "device.restart.action": "Restart",
  "device.restart.cancel": "Cancel",
  "device.restart.confirm": "Restart",
  "device.restart.confirmDescription": "Are you sure you want to restart the device? The device will be unavailable for several minutes.",
  "device.restart.confirmTitle": "Confirm device restart",
  "device.restart.error": "Error while restarting: {message}",
  "device.restart.success": "Device is restarting",
  "device.select.empty": "No device found",
  "device.select.label": "Device",
  "device.select.searchHint": "Type at least {count} characters to search devices",
  "device.title": "Device",
  "device.update.action": "Update",
  "device.update.adminDuration": "This operation may take several minutes.",
  "device.update.betaNotice": "This feature is currently in beta. We recommend updating during business hours so support is available in case the update fails. Thank you for your understanding.",
  "device.update.branchHint": "If you leave the field empty, the device's current branch will be used. When changing it, make sure the branch exists.",
  "device.update.branchLabel": "Change branch",
  "device.update.cancel": "Cancel",
  "device.update.confirm": "Update",
  "device.update.confirmTitle": "Are you sure you want to update the device?",
  "device.update.skipAppRunningCheck": "Ignore if app is not running",
  "device.update.startError": "Error starting device update",
  "device.updateStatus.failed": "Failed",
  "device.updateStatus.pending": "Running",
  "device.updateStatus.queued": "Queued",
  "device.updateStatus.success": "Completed",
  "device.vpnSessions.connected": "Connected",
  "device.vpnSessions.disconnected": "Disconnected",
  "device.vpnSessions.empty": "No connections recorded yet.",
  "device.vpnSessions.online": "Online",
  "device.vpnSessions.stillConnected": "Still connected",
  "device.vpnSessions.subtitle": "Showing the latest {count} connections.",
  "device.vpnSessions.title": "Connection history",
  "deviceBackups.confirmDescription": "Are you sure you want to create a new device backup?",
  "deviceBackups.confirmTitle": "Create backup?",
  "deviceBackups.create": "Create backup",
  "deviceBackups.download": "Download backup",
  "deviceBackups.downloadUrlError": "Failed to get download link",
  "deviceBackups.restore": "Restore from backup",
  "deviceBackups.show": "Show backups",
  "deviceBackups.table.date": "Backup date",
  "deviceBackups.table.size": "Size",
  "deviceBackups.title": "Backups",
  "deviceBackups.triggerError": "Error scheduling backup: {message}",
  "deviceBackups.triggerSuccess": "Backup was successfully scheduled",
  "deviceNotifications.count": "Notification count",
  "deviceNotifications.lastNotification": "Last notification",
  "deviceNotifications.loadError": "Error loading notifications",
  "deviceRestore.dialog.backupLabel": "Backup",
  "deviceRestore.dialog.cancel": "Close",
  "deviceRestore.dialog.confirmDescription": "The database of device {deviceName} will be overwritten with backup {backupName}. The app will be stopped for a few minutes. The device serial number will be preserved.",
  "deviceRestore.dialog.confirmTitle": "Restore backup?",
  "deviceRestore.dialog.error": "Failed to start the restore: {message}",
  "deviceRestore.dialog.noBackups": "No backups",
  "deviceRestore.dialog.serialMissing": "The serial number of this device is unknown. The restore will try to read it from the device; if it finds none, the serial number from the backup will remain — please check it manually.",
  "deviceRestore.dialog.serialPreserved": "Serial number {serialNumber} will be restored afterwards.",
  "deviceRestore.dialog.submit": "Restore",
  "deviceRestore.dialog.title": "Restore from backup",
  "deviceRestore.dialog.warning": "The database of device {deviceName} will be overwritten with the selected backup. The app will be stopped for a few minutes and the original database will be kept on the device as db.sqlite.pre-restore-*.",
  "deviceRestoreDetail.backupName": "Backup",
  "deviceRestoreDetail.createdAt": "Created",
  "deviceRestoreDetail.device": "Device",
  "deviceRestoreDetail.loadError": "Error loading the restore detail",
  "deviceRestoreDetail.logs": "Logs",
  "deviceRestoreDetail.sourceDevice": "Source device",
  "deviceRestoreDetail.startedBy": "Started by",
  "deviceRestoreDetail.status": "Status",
  "deviceRestoreDetail.title": "Device backup restore",
  "deviceRestoreDetail.titleSegment": "Restore",
  "deviceRestoreDetail.updatedAt": "Last change",
  "deviceSubscriptions.create": "Create subscription",
  "deviceSubscriptions.createError": "Error creating subscription",
  "deviceSubscriptions.empty": "No subscriptions",
  "deviceSubscriptions.manage": "Manage subscription",
  "deviceSubscriptions.manageError": "Error opening subscription management",
  "deviceSubscriptions.table.createdAt": "Creation date",
  "deviceSubscriptions.table.status": "Status",
  "deviceUpdateDetail.createdAt": "Created",
  "deviceUpdateDetail.device": "Device",
  "deviceUpdateDetail.loadError": "Error loading device update details",
  "deviceUpdateDetail.logs": "Logs",
  "deviceUpdateDetail.startedBy": "Started by",
  "deviceUpdateDetail.status": "Status",
  "deviceUpdateDetail.title": "Device update",
  "deviceUpdateDetail.titleSegment": "Update",
  "deviceUpdateDetail.updatedAt": "Last change",
  "deviceUpdateList.colDevice": "Device",
  "deviceUpdateList.colInternalIp": "Internal IP",
  "deviceUpdateList.colStartedBy": "Started by",
  "deviceUpdateList.colStatus": "Status",
  "deviceUpdateList.colUpdatedAt": "Last change",
  "deviceUpdateList.confirm": "Update",
  "deviceUpdateList.confirmTitle": "Device update",
  "deviceUpdateList.deviceIdsLabel": "Device IDs (comma-separated)",
  "deviceUpdateList.deviceOffline": "Device is offline",
  "deviceUpdateList.loadError": "Error loading device updates",
  "deviceUpdateList.openDevice": "Open device",
  "deviceUpdateList.title": "Device updates",
  "deviceUpdateList.titleSegment": "Updates",
  "deviceUpdateSource.device": "ze zařízení",
  "deviceUpdateSource.mcp": "Figgy",
  "deviceUpdateSource.portal": "z portálu",
  "deviceUpdateSource.unknown": "",
  "devices.columns.title": "Visible columns",
  "devices.filters.openAlert": "Open alert",
  "devices.head.createdAt": "Created",
  "devices.head.device": "Device",
  "devices.head.internalIp": "Internal IP",
  "devices.head.macAddress": "MAC address",
  "devices.head.onlineSince": "Online",
  "devices.head.serialNumber": "Serial number",
  "devices.head.status": "Status",
  "devices.head.version": "Version",
  "devices.open": "Open",
  "devices.plusActive": "Infigy Plus active",
  "devices.softwareVersion": "Software version",
  "devices.sort.firstUserAssignedAt": "First assigned user",
  "devices.sort.name": "Alphabetically",
  "devices.sort.title": "Sorting",
  "devices.title": "Devices",
  "devices.update": "Update",
  "devices.whyNoDevices": "Why don't I see any devices?",
  "digest.calls.answered": "Odbavené hovory",
  "digest.calls.average": "Průměrná délka hovoru (min)",
  "digest.calls.caller": "Volající",
  "digest.calls.count": "Hovorů",
  "digest.calls.heading": "Hovory",
  "digest.calls.installsPeriod": "Instalace za období",
  "digest.calls.installsTotal": "Instalace celkem",
  "digest.calls.minutes": "Minut",
  "digest.calls.missed": "Zmeškané hovory",
  "digest.calls.operator": "Operátor",
  "digest.calls.operators": "Nejvytíženější operátoři",
  "digest.calls.time": "Provoláno",
  "digest.calls.topCallers": "Nejaktivnější volající",
  "digest.calls.totalTime": "Provoláno (h:mm)",
  "digest.calls.uniqueCallers": "Unikátních volajících",
  "digest.figgy.active": "S aktivitou",
  "digest.figgy.activeConversations": "Konverzací s aktivitou",
  "digest.figgy.bySource": "Podle zdroje",
  "digest.figgy.byUser": "Nejaktivnější uživatelé",
  "digest.figgy.conversations": "Konverzací",
  "digest.figgy.errors": "Chybných odpovědí",
  "digest.figgy.fromFiggy": "Odpovědí",
  "digest.figgy.heading": "Figgy",
  "digest.figgy.messages": "Zpráv celkem",
  "digest.figgy.messagesFromFiggy": "Odpovědí od Figgy",
  "digest.figgy.messagesToFiggy": "Dotazů na Figgy",
  "digest.figgy.newConversations": "Nových konverzací",
  "digest.figgy.source": "Zdroj",
  "digest.figgy.source.gmail": "Gmail",
  "digest.figgy.source.portal": "Aplikace",
  "digest.figgy.source.routine": "Rutiny",
  "digest.figgy.source.slack": "Slack",
  "digest.figgy.source.user": "Web",
  "digest.figgy.toFiggy": "Dotazů",
  "digest.figgy.user": "Uživatel",
  "digest.from": "Od",
  "digest.installs.company": "Firma",
  "digest.installs.count": "Instalací",
  "digest.installs.heading": "Instalace",
  "digest.installs.topCompanies": "Nejaktivnější firmy",
  "digest.installs.total": "Instalací celkem",
  "digest.load": "Načíst",
  "digest.loading": "Načítám přehled. U delších období to může trvat i dvě minuty — čtou se všechny e-maily za období.",
  "digest.mail.correspondents": "Unikátních protistran",
  "digest.mail.excluded": "Vyřazeno jako automatické",
  "digest.mail.heading": "E-maily",
  "digest.mail.long": "Dlouhá",
  "digest.mail.messageCount": "Zpráv",
  "digest.mail.messageShare": "% zpráv",
  "digest.mail.name": "Jméno",
  "digest.mail.new": "Jednorázová",
  "digest.mail.perThread": "Zpráv na vlákno",
  "digest.mail.received": "Přijaté e-maily",
  "digest.mail.sender": "Odesílatel",
  "digest.mail.sent": "Odeslané e-maily",
  "digest.mail.short": "Krátká",
  "digest.mail.threadCount": "Vláken",
  "digest.mail.threadShare": "% vláken",
  "digest.mail.threadType": "Typ vlákna",
  "digest.mail.threads": "Vlákna (dlouhé = {min}+ zpráv)",
  "digest.mail.topSenders": "Nejaktivnější odesílatelé",
  "digest.period": "Období",
  "digest.periodLabel": "Období: {label} ({timeZone})",
  "digest.preset.custom": "Vlastní rozsah",
  "digest.preset.day": "Dnes",
  "digest.preset.last30d": "Posledních 30 dní",
  "digest.preset.last7d": "Posledních 7 dní",
  "digest.preset.lastMonth": "Minulý měsíc",
  "digest.preset.month": "Tento měsíc",
  "digest.preset.week": "Tento týden",
  "digest.preset.yesterday": "Včera",
  "digest.sectionUnavailable": "Sekce je nedostupná: {error}",
  "digest.title": "Přehled podpory",
  "digest.to": "Do (mimo)",
  "figgyChat.cancel": "Cancel",
  "figgyChat.composer.aiDisclaimer": "AI can make mistakes.",
  "figgyChat.composer.autoSend": "Hands-free",
  "figgyChat.composer.autoSendHint": "Hands-free: each dictated sentence sends itself once you pause",
  "figgyChat.composer.placeholder": "Write a message…",
  "figgyChat.conversation.delete": "Delete",
  "figgyChat.conversation.options": "Conversation options",
  "figgyChat.conversation.rename": "Rename",
  "figgyChat.conversation.untitled": "New conversation",
  "figgyChat.delete.body": "The conversation “{title}” will be permanently deleted. This cannot be undone.",
  "figgyChat.delete.confirm": "Delete",
  "figgyChat.delete.title": "Delete conversation?",
  "figgyChat.dictation.denied": "Microphone access was denied.",
  "figgyChat.dictation.expired": "Dictation expired. Please try again.",
  "figgyChat.dictation.failed": "Dictation failed. Please try again.",
  "figgyChat.dictation.notStarted": "Dictation could not be started.",
  "figgyChat.dictation.quota": "ElevenLabs quota exhausted.",
  "figgyChat.dictation.start": "Dictate a message",
  "figgyChat.dictation.stop": "Stop dictation",
  "figgyChat.kit.announce.completed": "Response complete",
  "figgyChat.kit.announce.started": "Figgy is responding",
  "figgyChat.kit.author.assistant": "Figgy",
  "figgyChat.kit.author.system": "System",
  "figgyChat.kit.author.user": "You",
  "figgyChat.kit.composer.aria": "Message",
  "figgyChat.kit.composer.attach": "Add attachment",
  "figgyChat.kit.composer.attachInput": "Upload file",
  "figgyChat.kit.composer.attachmentFallback": "Attachment",
  "figgyChat.kit.composer.removeAttachment": "Remove {fileName}",
  "figgyChat.kit.composer.send": "Send message",
  "figgyChat.kit.error": "Something went wrong",
  "figgyChat.kit.header.settings": "Settings",
  "figgyChat.kit.landmark.composer": "Message composer",
  "figgyChat.kit.landmark.conversationList": "Conversations",
  "figgyChat.kit.landmark.message": "Message",
  "figgyChat.kit.landmark.messageActions": "Message actions",
  "figgyChat.kit.landmark.messageList": "Message log",
  "figgyChat.kit.landmark.thread": "Conversation",
  "figgyChat.kit.list.search": "Search conversations",
  "figgyChat.kit.loading": "Loading…",
  "figgyChat.kit.message.copiedCode": "Copied",
  "figgyChat.kit.message.copy": "Copy",
  "figgyChat.kit.message.copyCode": "Copy code",
  "figgyChat.kit.message.deleted": "Deleted",
  "figgyChat.kit.message.edited": "Edited",
  "figgyChat.kit.message.reasoning": "Reasoning",
  "figgyChat.kit.message.reasoningStreaming": "Thinking…",
  "figgyChat.kit.reconnect": "Reconnect",
  "figgyChat.kit.retry": "Retry",
  "figgyChat.kit.status.cancelled": "Cancelled",
  "figgyChat.kit.status.error": "Error",
  "figgyChat.kit.status.pending": "Pending",
  "figgyChat.kit.status.read": "Read",
  "figgyChat.kit.status.sending": "Sending",
  "figgyChat.kit.status.sent": "Sent",
  "figgyChat.kit.status.streaming": "Streaming",
  "figgyChat.kit.suggestions": "Suggested prompts",
  "figgyChat.kit.thread.empty": "No messages yet",
  "figgyChat.kit.thread.emptyHelper": "Type a message to get started",
  "figgyChat.kit.thread.scrollToBottom": "Scroll to bottom",
  "figgyChat.kit.thread.scrollToBottomWithCount": "Scroll to bottom, {count, plural, one {# new message} other {# new messages}}",
  "figgyChat.kit.thread.unread": "New messages",
  "figgyChat.kit.tool.approve": "Approve",
  "figgyChat.kit.tool.awaitingApproval": "Awaiting approval",
  "figgyChat.kit.tool.completed": "Completed",
  "figgyChat.kit.tool.denied": "Denied",
  "figgyChat.kit.tool.deny": "Deny",
  "figgyChat.kit.tool.failed": "Failed",
  "figgyChat.kit.tool.input": "Tool called",
  "figgyChat.kit.tool.output": "Tool result",
  "figgyChat.kit.tool.running": "Running…",
  "figgyChat.kit.typing": "{count, plural, one {{names} is typing} other {{names} are typing}}",
  "figgyChat.list.back": "Back to conversations",
  "figgyChat.list.close": "Close conversations",
  "figgyChat.list.empty": "No conversations yet",
  "figgyChat.list.open": "Open conversations",
  "figgyChat.newChat": "New conversation",
  "figgyChat.rename.label": "Name",
  "figgyChat.rename.title": "Rename conversation",
  "figgyChat.save": "Save",
  "figgyChat.send.busy": "Figgy is still answering your previous message. Give it a moment, then try again.",
  "figgyChat.send.failed": "The message could not be sent. Please try again.",
  "figgyChat.send.lostContact": "We lost contact while waiting for the answer. It may still arrive — reopen this conversation in a moment.",
  "figgyChat.widget.ask": "Ask Figgy",
  "figgyChat.widget.close": "Close",
  "figgyChat.widget.exitFullscreen": "Exit fullscreen",
  "figgyChat.widget.fullscreen": "Fullscreen",
  "figgyChat.widget.newChat": "New conversation",
  "group.create.button": "Create group",
  "group.create.cancel": "Close",
  "group.create.conflict": "A group with this email already exists, another group with the same email cannot be created.",
  "group.create.emailLabel": "Email",
  "group.create.error": "Failed to create group",
  "group.create.infoIdentification": "The group is identified by email, but the email is not used for signing in to devices in the group. To use the group, please add the first users.",
  "group.create.infoSecurity": "A user can have the same email as the group, but ideally the group should contain individual user accounts to improve security.",
  "group.create.nameLabel": "Name",
  "group.create.submit": "Create",
  "group.create.success": "Group was created",
  "group.create.title": "Create group",
  "group.detail.company": "Company",
  "group.detail.createdAt": "Created",
  "group.detail.deviceAssignedAt": "Assigned",
  "group.detail.deviceName": "Name",
  "group.detail.devices": "Devices",
  "group.detail.email": "E-mail",
  "group.detail.memberEmail": "E-mail",
  "group.detail.members": "Members",
  "group.detail.name": "Name",
  "group.deviceCreate.cancel": "Close",
  "group.deviceCreate.error": "Failed to add device to group",
  "group.deviceCreate.submit": "Add",
  "group.deviceCreate.success": "Device assigned to group",
  "group.deviceCreate.title": "Assign device to group",
  "group.deviceRemove.cancelButton": "Cancel",
  "group.deviceRemove.confirmButton": "Remove",
  "group.deviceRemove.confirmTitle": "Are you sure you want to remove device {deviceName} from group {groupName}?",
  "group.deviceRemove.deviceSettingsWarning": "This group was assigned via the device settings. If the device is online, the group may be automatically reassigned.",
  "group.deviceRemove.error": "An error occurred",
  "group.deviceRemove.success": "Device successfully removed from group",
  "group.edit.button": "Edit",
  "group.edit.cancel": "Close",
  "group.edit.error": "Failed to save changes",
  "group.edit.nameLabel": "Name",
  "group.edit.submit": "Save",
  "group.edit.success": "Saved",
  "group.edit.title": "Edit group",
  "group.emailEdit.cancel": "Close",
  "group.emailEdit.conflict": "A group with this email already exists",
  "group.emailEdit.emailLabel": "Email",
  "group.emailEdit.error": "Failed to change the email",
  "group.emailEdit.submit": "Save",
  "group.emailEdit.success": "Group email has been changed",
  "group.emailEdit.title": "Change group email",
  "group.emailEdit.warning": "The email will be changed on the portal only. Change it in the settings of every device in the group as well, otherwise a new group with the original email may be created when they sync.",
  "group.remove.button": "Delete group",
  "group.remove.confirmDescription": "Are you sure you want to delete this group?",
  "group.remove.confirmTitle": "Delete group",
  "group.remove.error": "Failed to delete group",
  "group.remove.mustBeEmpty": "Group must be empty",
  "group.remove.success": "Group was successfully deleted",
  "group.sendEmail.button": "Send email",
  "group.sendEmail.cancel": "Close",
  "group.sendEmail.emailLabel": "Company email",
  "group.sendEmail.error": "Failed to send email",
  "group.sendEmail.submit": "Confirm",
  "group.sendEmail.success": "Sent",
  "group.sendEmail.title": "Send email to customer after successful group setup",
  "group.title": "Group",
  "group.userCreate.cancel": "Close",
  "group.userCreate.error": "Failed to add user to group",
  "group.userCreate.submit": "Add",
  "group.userCreate.success": "User assigned to group",
  "group.userCreate.title": "Assign user to group",
  "group.userRemove.cancelButton": "Cancel",
  "group.userRemove.confirmButton": "Remove",
  "group.userRemove.confirmTitle": "Are you sure you want to remove user {email} from group {groupName}?",
  "group.userRemove.error": "An error occurred",
  "group.userRemove.success": "User successfully removed from group",
  "groupSelect.label": "Group",
  "groups.table.company": "Company",
  "groups.table.createdAt": "Created",
  "groups.table.devices": "Devices",
  "groups.table.email": "E-mail",
  "groups.table.name": "Name",
  "groups.table.users": "Users",
  "groups.title": "Groups",
  "internalError.back": "Back to home page",
  "internalError.text": "Something went wrong on our side.{br}If the error persists, don't hesitate to contact us at {email}",
  "internalError.title": "An error occurred",
  "labels.create.error": "Error creating label",
  "labels.create.success": "Label was successfully created",
  "labels.loadError": "Error loading labels",
  "labels.newLabel": "New label",
  "labels.remove.confirmTitle": "Are you sure you want to remove this label?",
  "labels.remove.error": "Error removing label",
  "labels.remove.success": "Label was successfully removed",
  "labels.save": "Save label",
  "labels.table.name": "Name",
  "labels.table.type": "Type",
  "labels.type.private": "Private",
  "labels.type.public": "Public",
  "labelsSelect.close": "Close",
  "labelsSelect.label": "Labels",
  "labelsSelect.management": "Label management",
  "labelsSelect.managementTitle": "Label management",
  "layout.me.signOut": "Sign out",
  "mainLayout.energyTalk": "Join us on 5/28/2025 at {link}",
  "me.adminSettings": "Administrator settings",
  "me.apiTokens": "API tokens",
  "me.apiTokensLink": "Manage API tokens",
  "me.changePassword": "Change password",
  "me.devMode": "Developer mode",
  "me.email": "Email",
  "me.language": "Language",
  "me.title": "User account",
  "mqttCloud.tab.credentials": "Credentials",
  "mqttCloud.tab.online": "Online",
  "mqttConnected.load": "Load online devices",
  "mqttConnected.loadError": "Failed to load online devices",
  "mqttConnected.online": "Online",
  "mqttUsers.createError": "Error creating",
  "mqttUsers.created": "Created",
  "mqttUsers.detail.cancel": "Close",
  "mqttUsers.detail.loadError": "Error loading",
  "mqttUsers.detail.note": "Note",
  "mqttUsers.detail.password": "Password",
  "mqttUsers.detail.submit": "Save",
  "mqttUsers.detail.title": "User details",
  "mqttUsers.detail.user": "User",
  "mqttUsers.loadError": "Error loading",
  "mqttUsers.remove.cancel": "Cancel",
  "mqttUsers.remove.confirm": "Delete",
  "mqttUsers.remove.confirmDescription": "This action is irreversible.",
  "mqttUsers.remove.confirmTitle": "Are you sure you want to delete the user?",
  "mqttUsers.remove.error": "Error deleting user",
  "mqttUsers.remove.success": "User deleted",
  "mqttUsers.saveError": "Error saving",
  "mqttUsers.saved": "Saved",
  "mqttUsers.table.createdAt": "Created",
  "mqttUsers.table.note": "Note",
  "mqttUsers.table.password": "Password",
  "mqttUsers.table.user": "User",
  "nav.apiTokens": "API tokens",
  "nav.client": "Client section",
  "nav.dashboard": "Dashboard",
  "nav.deviceUpdates": "Device updates",
  "nav.devices": "Devices",
  "nav.digest": "Přehled podpory",
  "nav.groups": "Groups",
  "nav.partner": "Partner section",
  "nav.users": "Users",
  "pagination.rowsPerPage": "Per page",
  "partner.company.basicInfo": "Basic information",
  "partner.company.loading": "Loading",
  "partner.company.name": "Company name: {name}",
  "partner.company.serviceEmail": "Company service email: {email}",
  "partner.company.servicePassword": "Service password: {value}",
  "partner.company.showPassword": "Show password",
  "partner.company.title": "Company details",
  "partner.contact.hours": "9 AM - 4 PM",
  "partner.contact.serviceEmail": "Service email",
  "partner.contact.serviceLine": "Service hotline",
  "partner.contact.title": "Contact us",
  "partner.contact.weekdays": "Weekdays",
  "partner.docs.codex": "Our codex",
  "partner.docs.links": "Links",
  "partner.docs.techWiki": "Technical WIKI",
  "partner.docs.title": "Documentation",
  "partner.docs.userWiki": "User WIKI",
  "partner.docs.wiki": "Wiki pages",
  "partner.docs.wikiInfo": "Contains detailed service instructions for commissioning Infigy together with supported accessories such as PV inverter, boiler, heat pump, smart socket, and more.",
  "partnerPortal.title": "Partner section",
  "portalExit.close": "Close",
  "portalExit.text": "The connection to the device has been lost. The device either has no internet access, or an error has occurred on it.",
  "portalExit.title": "Device is not available",
  "portalVisits.active": "Active",
  "portalVisits.device": "Device",
  "portalVisits.empty": "No visits recorded yet.",
  "portalVisits.endedAt": "Ended",
  "portalVisits.ongoing": "Ongoing",
  "portalVisits.partner": "Partner",
  "portalVisits.startedAt": "Started",
  "portalVisits.summary.device": "Last {days} days: {visits, plural, one {# visit} other {# visits}} · {visitors, plural, one {# user} other {# users}} · {duration}. Showing the last {count} visits.",
  "portalVisits.summary.user": "Last {days} days: {visits, plural, one {# visit} other {# visits}} · {devices, plural, one {# device} other {# devices}} · {duration}. Showing the last {count} visits.",
  "portalVisits.title": "Portal usage",
  "portalVisits.user": "User",
  "searchField.clear": "Clear",
  "searchField.label": "Search",
  "setInDeviceSettings.tooltip": "Set on the device; to remove, visit service settings",
  "stripeCallback.error": "Error processing payment. Please try again.",
  "stripeCallback.failure": "Your payment could not be processed. If you have any questions, please contact us.",
  "stripeCallback.success": "Thank you for your payment. We will process it in a few seconds and redirect you back to Infigy.",
  "stripeCallback.title": "Processing payment",
  "subscription.transfer.cancel": "Close",
  "subscription.transfer.error": "Failed to transfer subscription",
  "subscription.transfer.submit": "Transfer",
  "subscription.transfer.success": "Subscription was transferred",
  "subscription.transfer.title": "Transfer subscription",
  "subscription.transfer.tooltip": "Transfer subscription to another device",
  "user.changePassword.confirmPassword": "Confirm new password",
  "user.changePassword.currentPassword": "Current password",
  "user.changePassword.error": "Failed to change password",
  "user.changePassword.incorrectPassword": "Incorrect password",
  "user.changePassword.newPassword": "New password",
  "user.changePassword.submit": "Change password",
  "user.changePassword.success": "Password changed",
  "user.confirmEmail.button": "Confirm manually",
  "user.confirmEmail.cancel": "Cancel",
  "user.confirmEmail.confirm": "Confirm",
  "user.confirmEmail.confirmTitle": "Are you sure you want to manually confirm email {email}?",
  "user.confirmEmail.error": "Failed to confirm email",
  "user.confirmEmail.success": "Email was confirmed",
  "user.create.button": "Create user",
  "user.create.cancel": "Close",
  "user.create.emailLabel": "Email",
  "user.create.error": "Failed to create user",
  "user.create.info": "The user will receive an invitation with a link to set a password.",
  "user.create.submit": "Create",
  "user.create.success": "User was created",
  "user.create.title": "Create user",
  "user.detail.createdAt": "Created",
  "user.detail.deviceInternalIp": "Internal IP",
  "user.detail.deviceName": "Name",
  "user.detail.deviceStatus": "Status",
  "user.detail.devices": "Devices",
  "user.detail.email": "Email",
  "user.detail.emailConfirmed": "Email confirmed",
  "user.detail.groupEmail": "E-mail",
  "user.detail.groupName": "Name",
  "user.detail.groupUpdatedAt": "Updated",
  "user.detail.groups": "Groups",
  "user.detail.invitedAt": "Invited",
  "user.detail.locale": "Jazyk",
  "user.locale.error": "Nepodařilo se změnit jazyk uživatele",
  "user.locale.success": "Jazyk uživatele změněn",
  "user.locale.unset": "Nenastaveno (podle prohlížeče)",
  "user.passwordReset.button": "Reset password",
  "user.passwordReset.cancel": "Cancel",
  "user.passwordReset.confirm": "Send",
  "user.passwordReset.confirmContent": "We recommend using this action, for example, when the user cannot find the invitation email.",
  "user.passwordReset.confirmTitle": "Are you sure you want to send a password reset email to user {email}?",
  "user.passwordReset.error": "Failed to send email",
  "user.passwordReset.success": "Email was sent",
  "user.setPassword.button": "Set password",
  "user.setPassword.cancel": "Close",
  "user.setPassword.confirmLabel": "Confirm password",
  "user.setPassword.error": "Failed to change password",
  "user.setPassword.info": "The preferred way to change the password is to send a password reset link, or to use the \"forgot password\" form.",
  "user.setPassword.passwordLabel": "Password",
  "user.setPassword.submit": "Set password",
  "user.setPassword.success": "Password changed",
  "user.setPassword.title": "Set password",
  "user.title": "User",
  "user.titleSegment": "User",
  "userDevice.create.cancel": "Close",
  "userDevice.create.error": "Failed to add device",
  "userDevice.create.submit": "Add",
  "userDevice.create.success": "Device added",
  "userDevice.create.title": "Assign user to device",
  "userDevice.remove.cancel": "Cancel",
  "userDevice.remove.confirm": "Remove",
  "userDevice.remove.confirmTitle": "Are you sure you want to remove device {deviceName} ({deviceId}) from user {email}?",
  "userDevice.remove.error": "An error occurred",
  "userDevice.remove.success": "Device successfully removed from user",
  "userSelect.label": "Users",
  "users.table.createdAt": "Created",
  "users.table.devices": "Devices",
  "users.table.email": "Email",
  "users.table.groups": "Groups",
  "users.table.role": "Role",
  "users.title": "Users",
  "virtualAddress.copiedAddress": "Address copied to clipboard",
  "virtualAddress.copiedSsh": "SSH command copied to clipboard",
  "virtualAddress.copyAddress": "Copy address",
  "virtualAddress.copySsh": "Copy SSH command"
}